<template>
  <div class="play-body">
    <div class="play-header" :class="{ headerBlack: changeSkin }">
      <div class="play-header-box">
        <ul class="play-ul" style="float: left;">
          <li class="play-li play-logo-box">
            <div class="play-logo" @click="enterHome();" :style="'background-image: url('+webSite.enter_game_logo+');'"></div>
          </li>
          <li class="play-li play-pc">
            <i class="play-pc-icon icon-front"></i>
            <span>保存账号</span>
            <i class="play-down"></i>
            <div class="play-pc-box">
              <span @click="toDesktop">保存到桌面</span>
              <span @click="toAddFavorite">加入收藏</span>
            </div>
          </li>
          <li class="play-li play-game" style="display: inline-flex;">
            <router-link :to="gameDevice == 1 ? '/webOfficial/'+gameTag : '/mobileOfficial/'+gameTag" 
              target="_blank" class="play-official-div">
              <i class="play-game-icon icon-front"></i>
              <span>{{gameName}}</span>
            </router-link>
          </li>
          <li class="play-li play-service">
            {{ serviceName }}
            <i class="play-down"></i>
            <div class="play-service-box">
              <div class="play-service-item">
                <i class="play-open-icon icon-front"></i>
                <span class="play-service-label">最新开服</span>
                <span class="play-service-line" style="width: 235px;"></span>
                <span class="play-service-more" @click="enterService">更多区服></span>
              </div>
              <ul class="service-ul">
                <li class="service-li" v-for="(item,index) in newServiceList"
                :key="index" @click="enterGameExact(item.game_gid,item.game_sid)">{{item.game_area_name}} {{new Date(item.game_area_time).Format("MM-dd hh:mm")}}</li>
              </ul>
              <div class="play-service-item">
                <i class="play-history-icon icon-front"></i>
                <span class="play-service-label">我最近玩过的</span>
                <span class="play-service-line" style="width: 280px;margin-right: 0;"></span>
              </div>
              <ul class="history-ul">
                <li class="history-li" v-for="(item,index) in historyList" :key="index">
                  <span class="history-title">{{item.game_name}}[{{item.game_area_name}}]</span>
                  <span class="history-time">{{handleTime(item.game_area_time)}}</span>
                  <span class="history-game" @click='enterGameSelect(item.game_device,item.game_gid,item.game_sid,item.game_out_sid,item.game_tag)'>开始游戏</span>
                </li>
              </ul>
            </div>
          </li>
          <li class="play-li" @click="enterName">
            <i class="ic-name"></i>
            <span style="color: #ff2801;">冠名</span>
          </li>
          <li class="play-li" style="position: relative;margin-right: 5px;">
            <i class="play-chat-icon icon-front"></i>
            <span>微信公众号</span>
            <div class="play-chat-box">
              <img class="common-qr-img" :src="webSite.wechat_public">
              <div class="common-qr-mask">
                <div class="common-qr-scan"></div>
              </div>
            </div>
          </li>
          <li class="play-li" style="width: 300px;display: flex;overflow: hidden;">     
            <i class="play-notice-icon icon-front"></i>
            <div class="loop-container" @mouseenter="stopLooper" @mouseleave="startLooper">
              <ul :class="{'looper-animate':animateUp == true}">
                <li v-for="(item,index) in newsList" :key="index" @click="enterInformationDetails(item.information_type,item.information_id)">{{item.information_title}}</li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="play-ul" style="float: right;">
          <li class="play-li" @click="enterUser" style="margin-right: 5px;">
            <img class="play-account-icon" :src="userAvatar"/>
            <span class="play-account-user">{{ userNickname }}({{userAccount}})</span>
            <img :src="vipList[userVip].vsrc" :class="'vip-level-'+userVip"></img>
          </li>
          <li class="play-li play-qq" @click="enterQq">
            <i class="play-qq-icon icon-front"></i>
            <span>加入qq群</span>
          </li>
          <li class="play-li play-message" @click="enterMessage">
            <i class="play-message-icon icon-front"></i>
            <span>消息</span>
          </li>
          <li class="play-li play-recharge" @click="enterRecharge">
            <i class="play-recharge-icon icon-front"></i>
            <span>充值</span>
          </li>
          <li class="play-li play-gift" @click="enterGift">
            <i class="play-gift-icon icon-front"></i>
            <span>礼包</span>
          </li>
          <li class="play-li play-skin" @click="enterSkin">
            <i class="play-skin-icon icon-front"></i>
            <span>换肤</span>
          </li>
          <li class="play-li play-customer" @click="enterCustomer">
            <i class="play-customer-icon icon-front"></i>
            <span>客服</span>
          </li>
          <li class="play-li" @click="enterApk">
            <img class="play-box-icon" src="../../assets/image/g_down.gif"/>
            <span class="play-box">游戏福利盒子</span>
          </li>
          <li class="play-li" :class="changeSkin ? 'playBlack':'playWhite'"> 
            <Handle :type="1"/>
          </li>
        </ul>
      </div>
    </div>
    <iframe :src=enterGameAddress frameborder="0" style="width: 100%;height: 96%;"></iframe>
    <div class="modal" v-show="isNotAdultState">
      <div class="enter-window-content">
        <div class="window-close-body">
          <span class="window-close-span">警告</span>
          <img src="../../assets/image/window_close_normal.png" class="window-close" @click="closeAdult">
        </div>
        <p style="width: 90%;margin: 20px auto 0 auto;">根据国家相关规定,<span style="color:red;">您需要先完成实名认证之后才能正常游戏。</span></p>
      </div>
    </div>
    <div class="modal" v-show="isNotRealNameState">
      <div class="enter-window-content">
        <div class="window-close-body">
          <span class="window-close-span">为了您的合法权益,请完善账户信息</span>
          <img src="../../assets/image/window_close_normal.png" class="window-close" @click="closeRealName">
        </div>
        <Form class="window-real-name-form" ref="realNameBean" :model="realNameBean" 
        :rules="realNameRule">
          <FormItem prop="name">
            <Input type="text" v-model.trim="realNameBean.user_info_real_name" placeholder="请输入您的姓名"
              style="width: 330px"></Input>     
          </FormItem>
          <!-- 身份证号码 -->
          <FormItem prop="id_card">
            <Input v-model.trim="realNameBean.user_info_id_card" placeholder="请输入身份证号码"
              style="width: 330px"></Input>
          </FormItem>
        </Form>
        <div class="window-form-submit" @click="realNameSubmit('realNameBean')">立即认证</div>
        <p style="width: 90%;margin: 0 auto;">根据国家相关规定,<span style="color:red;">您需要先完成实名认证之后才能正常游戏。</span>完成认证后,请重新登陆游戏。</p>
      </div>
    </div>
    <div class="suspend-tip-box" v-if="tipState">
      <div class="suspend-tip-mask"></div>
      <div class="modal-enter-content">
        <div class="modal-header">
          <h1 style="font-size: 20px;color: #000;">提示</h1>
          <span class="modal-close" @click="closeTipModal">×</span>
        </div>
        <div class="modal-body">
          <span class="modal-msg">{{tipMsg}}</span>
          <div class="modal-button" @click="closeTipModal">确定</div>
        </div>
      </div>
    </div>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
    @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
    @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Handle from '../../components/Handle'
  import SuspendMember from '../../components/SuspendMember';
  export default {
    metaInfo(){
      return{
        title:"开始游戏_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    asyncData({store,route}){
      return store.dispatch('initSeo',{store:store});
    },
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseQrAddress(){
        return this.$store.state.constant.baseQrAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      webSite(){
        return this.$store.state.home.webSite;
      },
      vipList(){
        return this.$store.state.constant.vipList;
      },
    },
    data() {
      //真实姓名验证
      const validateRealName = (rule, value, callback) => {
        let reg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/;
        if (reg.test(value)) {
          this.isRealName = true;
          callback();
        } else {
          this.isRealName = false;
          callback(new Error("请输入真实姓名"));
        }
      };
      //身份证的验证
      const validateIdCard = (rule, value, callback) => {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value)) {
          this.isIdCard = true;
          callback();
        } else {
          this.isIdCard = false;
          callback(new Error("*请输入真实身份证号码"));
        }
      };
      return {
        loginState:false,
        serviceName:'双线1区',  //获取的区服名称
        userNickname:"",
        userAccount:"",
        userAvatar:"",
        userVip:0,
        gameName:"",
        gameTag:'',
        gameDevice:0,
        gameGid:"", //游戏序号
        gameSidId:0, //游戏区服序号
        gameSid:0, //游戏区服sid
        beforeUnloadTime:'',
        gapTime:'',
        enterGameAddress: '',  //游戏地址
        showSuspend: true,  //控制是否隐藏
        changeSkin: false,  //控制换皮肤的索引
        isNotRealNameState:false,  // 0 成年 1 未成年 2 未实名
        isNotAdultState:false,
        newServiceList:[],
        historyList:[],
        realNameBean:{
          user_info_id_card: "",
          user_info_real_name: ""
        },
        realNameRule: {
          user_info_real_name: [{ max: 20, min: 4, validator: validateRealName, trigger: "blur" }],
          user_info_id_card: [{ validator: validateIdCard, trigger: "blur" }]
        },
        newsList:[],  //获取的资讯列表
        animateUp:false,
        timer:'',
        suspendState:false,
        suspendType:0,
        tipState:false,
        tipMsg:"",
        maintainMode:0,
        maintainHint:""
      };
    },
    destroyed(){
      clearInterval(this.timer);
    },
    methods: {
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      closeTipModal(){
        this.tipState = false;
        if(this.maintainMode == 1){
          this.$router.push({path: "/"})
        }
      },
      //公共轮播开启
      scrollAnimate(){
        this.animateUp = true;
        setTimeout(() => {
          this.newsList.push(this.newsList[0])
          this.newsList.shift()
          this.animateUp = false;
        }, 900);
      },
      stopLooper(){
        clearInterval(this.timer);
      },
      startLooper(){
        this.timer = setInterval(this.scrollAnimate,1800);
      },

      //收藏本站
      toAddFavorite(){
        let url = "101游戏";
        let title = location.href;
        try{
          window.external.addFavorite(url,title);
        }catch(e){
          try{
            window.sidebar.addPanel(title,url,"");
          }catch(e){
            alert("抱歉,您所使用的浏览器无法完成此操作。\n\n加入收藏失败,请使用Ctrl+D进行添加");
          }
        }
      },
      //保存到桌面
      toDesktop(){
        window.open(this.baseAddress+'download/url?type=2',"_blank");
      },
      handleTime(value){
        let time = new Date().getTime();
        let now = (time - value)/1000;
        if(now < 60){
          return "刚刚";
        }else if(60 < now && now < 3600){
          return Math.floor(now/(3600))+"分钟前";
        }else if(3600 < now && now < 86400){
          return Math.floor(now/(3600))+"小时前";
        }else if(86400 < now && now < 2592000){
          return Math.floor(now/(86400))+"天前";
        }else if(2592000 < now && now < 31104000){
          return Math.floor(now/(2592000))+"月前";
        }else{
          return Math.floor(now/(31104000))+"年前";
        }
      },

      realNameSubmit(name) {
        this.$refs[name].validate((valid) => {
          this.$http.post('/update_web_mine_certify',{   
            data:this.realNameBean
          }).then(res=>{       
            if (res.data.code==2000) {
              this.tipMsg = '实名认证成功!';
              this.tipState = true;
              this.isNotRealNameState = false;
              location.reload();
            } else {
              this.tipMsg = '实名认证成功!';
              this.tipState = true;
            }
          })   
        })
      },
      //请求默认的标签头数据
      queryWebGameLogin(){
        if(this.$route.query.sid == undefined){
          this.$route.query.sid = 0;
        }
        this.$http.post('/query_web_game_login?gid='+this.$route.query.gid+"&sid="+this.$route.query.sid)
        .then(res=>{
          if(res.data.code == 2000){
            var bean = res.data.data;
            if(bean.game_area_name.length > 0) {
              this.serviceName = bean.game_area_name;
            }
            if(bean.news.length > 0){
              this.newsList = bean.news;
              this.timer = setInterval(this.scrollAnimate,1000);
            }
            this.newServiceList = bean.service;
            this.gameTag = bean.game_tag;
            this.gameGid = bean.game_gid;
            this.gameSid = bean.game_sid;
            this.gameSidId = bean.game_sid_id;
            this.gameDevice = bean.game_device;
            this.gameName = bean.game_name;
            document.title = bean.game_name +" "+this.serviceName+"_101游戏平台_最新网页游戏_H5游戏在线玩_最好玩的手机游戏";
          }else{
            this.launchType = 2;
            this.enterLogin();
          } 
        });
      },
      queryMaintain(){
        this.$http.get('/query_maintain')
        .then(res=>{
          if(res.data.code == 2000){
            this.maintainMode = res.data.data.maintain_mode;
            this.maintainHint = res.data.data.maintain_hint;
            if(this.maintainMode == 1){
              this.tipState = true;
              this.tipMsg = this.maintainHint;
            }else{
              this.requestWebLogin();
            }
          }
        });
      },
      //请求游戏的方法
      requestWebLogin(){
        if(this.$route.query.sid == undefined){
          this.$route.query.sid = 0;
        }
        this.$http.post('/request_web_login',{},
        {params:{
          gid:this.$route.query.gid,
          sid:this.$route.query.sid
        }
        }).then(res=>{
          if(res.data.code == 2000){
            if(res.data.total == 1){
              this.isNotAdultState = true;
            }else if(res.data.total == 2){
              this.isNotRealNameState = true;
            }else if(res.data.total == 0){
              this.enterGameAddress = res.data.data;
            }
          }else{
            this.tipMsg = res.data.msg;
            this.tipState = true;
          }
        })
      },
      beforeUnloadHandler(e){
        this.beforeUnloadTime = new Date().getTime();
      },
      unloadHandler(e){
        this.gapTime = new Date().getTime() - this.beforeUnloadTime;
        //判断是窗口关闭还是刷新
        if (this.gapTime >= 5) {
          $.ajax({
            url: this.baseAddress+'web_online?gid='+this.$route.query.gid+"&sid="+this.gameService,
            type: 'get',
            contentType:'application/json',
            dataType: "json",
            async: false,
            headers:{"token":window.sessionStorage.getItem("token")}
          })
        }
      },
      initGame(){
        this.queryWebGameLogin();
        //获取储存在浏览器里面的用户名
        this.userAvatar = window.sessionStorage.getItem("userAvatar");
        this.userVip = window.sessionStorage.getItem("userVip");
        this.userNickname = window.sessionStorage.getItem("userNickname");
        this.userAccount = window.sessionStorage.getItem("userAccount");
        this.historyList = JSON.parse(window.sessionStorage.getItem("gameHistoryList"));
        this.historyList = this.historyList.slice(0,3);
        this.queryMaintain();
      }, 
      enterName(){
        window.open(this.$router.resolve({name: "name"}).href,'_blank');
      },
      enterGameExact(gid,sid){
        if(this.loginState){
          window.open(this.$router.resolve({name:'gameEnter', query:{gid:gid,sid:sid}}).href,'_blank');
        }else{
          this.enterLogin();
        }
      },
      enterGameSelect(type,gid,sid,out_sid,tag){
        if(type == 1){
          this.enterGameExact(gid,sid);
        }else if(type == 3){
          this.enterH5Game(gid,out_sid,tag);
        }else{
          this.enterDownload(tag);
        }
      },
      enterLogin(){
        this.changeSuspendType(0);
        this.changeSuspendState(true);
      }, 
      enterH5Game(gid,out_sid,tag){
        window.open(this.$router.resolve({name:'enterH5', query:{gid:gid,sid:out_sid,path:this.$route.path,tag:tag}}).href,'_blank');
      },
      enterDownload(value){
        window.open(this.$router.resolve({ name: 'transfer', query: { tag: value, type: this.GameTransfer} }).href, '_blank'); 
      },
      //携带资讯id跳转资讯页面
      enterInformationDetails(index){
        let type = this.newsList[index].informaiton_type;
        let value = this.newsList[index].information_id;
        if(type == 8){
          window.open(this.$router.resolve({name: "informationNotice",query:{news_id:value}}).href,'_blank');
        }else{
          window.open(this.$router.resolve({name: "informationDetails",query:{news_id:value}}).href,'_blank');
        }
      },  
      enterCustomer(){
        window.open(this.webSite.one_qq_url,'_blank');
      },
      enterRealName(){
        window.open(this.$router.resolve({name: "mineCertify"}).href,'_blank');
      },
      closeRealName(){
        this.isNotRealNameState = false;
      },
      closeAdult(){
        this.isNotAdultState = false;
        if(this.$route.query.path !== ""){
          this.$router.push({path:this.$route.query.path});
        }else{
          this.enterHome();
        }
      },
      enterHome(){
        window.open(this.$router.resolve({path: "/"}).href,'_blank');
      },
      enterApk(){
        window.open(this.$router.resolve({name:'apkDownload'}).href,"_blank");
      },
      //跳转充值(gid =唯一游戏序号 sid = 区服序号(game_area_id))
      enterRecharge(){
        window.open(this.$router.resolve({name: "recharge",query:{gid:this.gameGid,sid:this.gameSidId,device:this.gameDevice}}).href,'_blank');
      }, 
      enterUser(){
        window.open(this.$router.resolve({name: "mineInfo"}).href,'_blank');
      },
      enterMessage(){
        window.open(this.$router.resolve({name: "mineMessage"}).href,'_blank');
      },
      enterService(){
        window.open(this.$router.resolve({name:'openTable'}).href,"_blank");
      },
      //跳转到礼包界
      enterGift(){
        window.open(this.$router.resolve({name: "gift"}).href,'_blank');
      },
      enterSkin(){
        this.changeSkin = !this.changeSkin;
      },
      enterQq(){
        window.open(this.webSite.qq_group,'_blank');
      },
    },
    mounted(){
      window.addEventListener('beforeunload', e => this.beforeUnloadHandler(e));
      window.addEventListener('unload', e => this.unloadHandler(e));
      if(window.sessionStorage.getItem("token") != null){
        this.loginState = true;
        this.initGame();
      }else{
        this.launchType = 1;
        this.enterLogin();
      }   
    },
    destroyed(){
      clearInterval(this.timer);
      window.removeEventListener('beforeunload', e => this.beforeUnloadHandler(e));
      window.removeEventListener('unload', e => this.unloadHandler(e));
    },
    components:{ Handle ,SuspendMember},
    watch:{
      loginState:function(value){
        if(value){
          if(this.launchType == 1){
            this.initGame();
          }else if(this.launchType == 2){
            this.queryWebGameLogin();
          }
        }
      },
    },
  };
</script>
<style src="@/assets/css/enter_game.css" scoped></style>
<style>
  body{
    width: 100%;
    height: 100%;
  }
  
  #app{
    width: 100%;
    height: 100%;
  }

  .play-ul .play-li .handle-box{
    height: 30px;
    background: url("../../assets/image/game_header_black_normal.png");

  }

  .play-ul .playBlack .handle-box{
    height: 30px;
    background: url("../../assets/image/game_header_white_normal.png");
  }

  .play-ul .play-li .handle-all-box-text{
    height: 30px;
    line-height: 30px;
  }

  .play-official-div{
    width: auto;
    display: flex;
    color: #fff;
  }

  .headerBlack .play-official-div{
    color: #000;
  }

  .play-ul .play-li .handle-menu-body{
    top: 30px;
  }
</style>
